// extracted by mini-css-extract-plugin
export default {"imgSection":"Image_imgSection__kjCRh","img":"Image_img__4YtUA"};